import cn from 'classnames';
import { TQuantitySelector } from '@scenes/HomeHub/homehub.types';

import styles from '../selectors.module.scss';

const QuantitySelector = ({ quantity = 1, onClick }: TQuantitySelector) => {
  const onQuantityAdd = () => {
    onClick(quantity + 1);
  };
  const onQuantitySubtract = () => {
    if (quantity > 1) {
      onClick(quantity - 1);
    }
  };
  return (
    <div className={styles.qtyContainer}>
      <div className={styles.qtyButton} onClick={onQuantityAdd}>
        +
      </div>
      <div className={styles.qty}>{quantity}</div>
      <div className={cn(styles.qtyButton, quantity === 1 ? styles.disabled : '')} onClick={onQuantitySubtract}>
        -
      </div>
    </div>
  );
};

export default QuantitySelector;
